"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoadingMachine = exports.getInitialContext = void 0;
const xstate_1 = require("xstate");
const constants_1 = require("../../../lib/constants");
const actions_loadingMachine_1 = __importStar(require("./actions.loadingMachine"));
const guards_loadingMachine_1 = __importStar(require("./guards.loadingMachine"));
const services_loadingMachine_1 = __importStar(require("./services.loadingMachine"));
/**
 * Initial context for the machine
 *
 * @returns {LoadingMachineContext} initial context
 */
const getInitialContext = () => ({
    appointment: undefined,
    provider: undefined,
    appointmentId: '',
    capabilities: undefined,
    services: {
        getAppointment: () => Promise.resolve({}),
        getProvider: () => Promise.resolve({})
    }
});
exports.getInitialContext = getInitialContext;
/**
 * Creates a machine to handle loading states
 * @description This machine should be used as a sub machine
 *
 * @param {LoadingMachineContext} initialContext Initial context for the machine
 * @returns
 */
const createLoadingMachine = (initialContext = (0, exports.getInitialContext)()) => (0, xstate_1.createMachine)({
    id: 'loaderMachine',
    initial: constants_1.states.routing,
    context: initialContext,
    states: {
        [constants_1.states.routing]: {
            always: [
                {
                    cond: guards_loadingMachine_1.isAppointmentNotFetched,
                    target: constants_1.states.fetchAppointment
                },
                {
                    cond: guards_loadingMachine_1.isProvidertNotFetched,
                    target: constants_1.states.fetchProvider
                },
                {
                    target: constants_1.states.done
                }
            ]
        },
        [constants_1.states.fetchAppointment]: {
            invoke: {
                id: 'getAppointment',
                src: services_loadingMachine_1.getAppointment,
                onDone: {
                    actions: [actions_loadingMachine_1.setAppointment, actions_loadingMachine_1.setCapabilities],
                    target: constants_1.states.fetchProvider
                },
                onError: {
                    target: constants_1.states.error
                }
            }
        },
        [constants_1.states.fetchProvider]: {
            invoke: {
                id: 'getProvider',
                src: services_loadingMachine_1.getProvider,
                onDone: {
                    target: constants_1.states.done,
                    actions: [actions_loadingMachine_1.setProvider]
                },
                onError: {
                    target: constants_1.states.error
                }
            }
        },
        [constants_1.states.done]: {
            entry: actions_loadingMachine_1.sendParentDone
        },
        [constants_1.states.error]: {
            entry: actions_loadingMachine_1.sendParentExit
        }
    }
}, {
    guards: guards_loadingMachine_1.default,
    services: services_loadingMachine_1.default,
    actions: actions_loadingMachine_1.default
});
exports.createLoadingMachine = createLoadingMachine;
//# sourceMappingURL=loadingMachine.js.map